import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { HttpStatusCode } from '@angular/common/http';
import { Router } from '@angular/router';
import { GestionTitreService } from '@services/navigation/gestion-titre.service';
import { NavigationService } from '@services/navigation/navigation.service';
import { ContexteModificationEnum } from '../../constantes/contexte-modification.enum';
import { CybermetrieCoordonneesService } from '@services/cybermetrie/cybermetrie.service';
import { AccessibiliteService } from '@services/accessibilite.service';

@Component({
  selector: 'app-page-erreur',
  templateUrl: './page-erreur.component.html',
  standalone: false,
})
export class PageErreurComponent implements OnInit, AfterViewInit {
  private readonly router = inject(Router);
  private readonly gestionTitreService = inject(GestionTitreService);
  private readonly navigationService = inject(NavigationService);
  private readonly cybermetrieCoordonneesService = inject(CybermetrieCoordonneesService);
  private readonly accessibiliteService = inject(AccessibiliteService);

  estErreurSysteme: boolean = true;
  estFinDeParcours: boolean = false;
  erreurFinParcours: string[] = ['CAAD.400501', 'CAAD.400502', 'CAAD.700121'];
  status!: string;
  codeErreur!: string;
  messageErreur!: string;
  context!: ContexteModificationEnum | undefined;

  constructor() {
    const navigation = this.router.currentNavigation();
    this.status = navigation?.extras?.state?.status as string;
    this.codeErreur = navigation?.extras?.state?.codeErreur as string;
    this.messageErreur = navigation?.extras?.state?.messageErreur as string;
    this.context = (navigation?.extras?.state?.context as ContexteModificationEnum) || undefined;
  }

  ngOnInit(): void {
    this.estFinDeParcours = this.erreurFinParcours.includes(this.codeErreur);
    if (this.estFinDeParcours) {
      this.navigationService.naviguerVersFinParcours(
        this.status,
        this.codeErreur,
        this.messageErreur,
      );
    } else {
      this.gestionTitreService.addTitreOnglet('titreOnglet.pageErreur');
      this.estErreurSysteme = this.status !== HttpStatusCode.ServiceUnavailable.toString();
      this.cybermetrieCoordonneesService.transactionErreurTechnique(this.context, [
        this.status,
        this.codeErreur ?? null,
        this.messageErreur ?? null,
      ]);
    }
  }

  ngAfterViewInit(): void {
    this.accessibiliteService.setFocus('#titreErreur');
  }
}
